import { Link } from "react-router";
import { useTelegramInfo } from "../telegram/botLinks";
import styles from "./SiteFooter.module.css";

// Подвал (макет, версия 34): как это работает, вопросы, документы, возврат и «Бот в Telegram»
// — если бот запускался на сервере.
export const FOOTER_LINKS = [
  { to: "/how", label: "Как это работает" },
  { to: "/faq", label: "Вопросы" },
  { to: "/docs", label: "Документы" },
  { to: "/docs/refund", label: "Возврат" },
];

export function SiteFooter({ links }: { links?: { to: string; label: string }[] }) {
  const footerLinks = links ?? FOOTER_LINKS;
  const botUrl = useTelegramInfo().data?.bot_url ?? null;
  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        {footerLinks.map((link) => (
          <Link key={link.to + link.label} to={link.to}>
            {link.label}
          </Link>
        ))}
        {botUrl !== null && (
          <a href={botUrl} target="_blank" rel="noopener noreferrer">
            Бот в Telegram
          </a>
        )}
        <span className={styles.copyright}>© Селфигурка, 2026</span>
      </div>
    </footer>
  );
}
